export const homeNewsRoomData = {
  quote: `“With its massive list of features and intuitive design, Joy is a one-stop shop for organizing every single wedding detail.”`,
  quoteImageSrc: 'home/pr-logos/instyle_logo.svg',
} as const;
